import React from 'react';
import { Layout, Row, Col, Typography, Divider, Space, Flex, Image } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const { Footer: AntFooter } = Layout;
const { Text, Title } = Typography;

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <AntFooter className="app-footer">
      <Space direction="vertical" size="large" className="footer-content">
        <Row gutter={[32, 32]} justify="space-between" wrap className="footer-row">
          {/* Logo and Company Info */}
          <Col xs={24} md={16} className="footer-section footer-company-col" flex="auto">
            <Space direction="vertical" size="middle" className="footer-company-space">
              <Flex align="center" gap="small" className="footer-logo">
                <Image 
                  src="/logo.png" 
                  alt="ATPlay" 
                  className="footer-logo-image"
                  preview={false}
                  fallback="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='32'%3E%3Ctext x='0' y='24' font-size='20' font-weight='bold' fill='%231890ff'%3EATPlay%3C/text%3E%3C/svg%3E"
                />
              </Flex>
              <Text className="company-name">{t('footer.companyName')}</Text>
              <Space direction="vertical" size="small" className="company-info">
                <Text>{t('footer.taxCode')}</Text>
                <Text>{t('footer.representative')}</Text>
                <Text>{t('footer.address')}</Text>
                <Text>{t('footer.phone')}</Text>
                <Text>{t('footer.email')}</Text>
              </Space>
            </Space>
          </Col>

          {/* Explore and Support Container */}
          <Col xs={24} md={8} flex="auto" className="footer-nav-col">
            <Flex gap={64} justify="space-between" wrap="wrap" className="footer-nav-flex">
              {/* Explore Section */}
              <Space direction="vertical" size="middle" className="footer-section footer-nav-section">
                <Title level={5} className="footer-section-title">{t('footer.explore')}</Title>
                <Space direction="vertical" size="small" className="footer-links">
                  <Link to="/agencies">{t('footer.agenciesList')}</Link>
                </Space>
              </Space>

              {/* Support Section */}
              <Space direction="vertical" size="middle" className="footer-section footer-nav-section">
                <Title level={5} className="footer-section-title">{t('footer.support')}</Title>
                <Space direction="vertical" size="small" className="footer-links">
                  <Link to="/deposit-guide">{t('footer.depositGuide')}</Link>
                  {/* <Link to="/faq">{t('footer.faq')}</Link> */}
                  <Link to="/contact">{t('footer.customerCare')}</Link>
                  <Link to="/contact">{t('footer.contact')}</Link>
                </Space>
              </Space>
            </Flex>
          </Col>
        </Row>

        <Divider className="footer-divider" />

        {/* Bottom Section */}
        <Row justify="space-between" align="middle" className="footer-bottom-row">
          <Col xs={24} sm={12}>
            <Text className="copyright">
              {t('footer.copyright', { year: currentYear })}
            </Text>
          </Col>
          <Col xs={24} sm={12} className="policy-links">
            <Link to="/dieu-khoan-dieu-kien" className="policy-link">{t('footer.terms')}</Link>
            <Link to="/chinh-sach-bao-mat" className="policy-link">{t('footer.privacy')}</Link>
          </Col>
        </Row>
      </Space>
    </AntFooter>
  );
};

export default Footer;
